import { usePermissions } from 'contexts/PermissionsContext';
import { useEffect } from 'react';
import { useDebug } from 'shared/debug/debug_store';
import { stopEvent } from 'utils/event';
import { KeyboardEventCode } from 'utils/key_codes';

export function useDebugModeShortcut() {
    const { canViewDebug } = usePermissions();

    const { toggleIsDebugMode } = useDebug();

    useEffect(() => {
        if (!canViewDebug) {
            return undefined;
        }

        const onKeyDown = (event: KeyboardEvent) => {
            if (event.altKey && event.code === KeyboardEventCode.KeyG) {
                stopEvent(event);
                toggleIsDebugMode();
            }
        };

        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [toggleIsDebugMode, canViewDebug]);
}
